import useLocationGuestAiSummary from './useLocationGuestAiSummary'

export const api = {
  wingitnorthLocationGuestAiSummary: useLocationGuestAiSummary,
}
